// Результат импорта напрямую не используется внутри модуля, поэтому импортируем так,
// чтобы TS сохранил импорт без опции "importsNotUsedAsValues": "preserve" (https://www.typescriptlang.org/tsconfig#importsNotUsedAsValues)
import 'OK/pms!featuresConfiguration';

import { MODAL_LOADER_SHOW, MODAL_LOADER_HIDE } from 'OK/LayersEventBuses';
import { getInternetQuality, InternetQuality } from 'OK/InternetQuality';
import { IFeaturesConfiguration } from '@ok/interfaces/features/IFeaturesConfiguration';

export let isLayerLoaded = false;

/**
 * Возвращает настройки виджета загрузки фото.
 */
function isSmartLayerLoaderEnabled(): boolean {
    // Так как модуль используется как в реакте, так и в модулях, обычный pms!featuresConfiguration работать не будет
    const config = window.cfgStore?.getCfg<IFeaturesConfiguration>('featuresConfiguration');
    return config?.isSmartLayerLoaderEnabled || false;
}

export function startLoad() {
    if (isSmartLayerLoaderEnabled() && getInternetQuality() === InternetQuality.GOOD) {
        return;
    }
    isLayerLoaded = false;
    MODAL_LOADER_SHOW.emit(null);
}

export function endLoad(forceEnd = false) {
    if (!isLayerLoaded || forceEnd) {
        isLayerLoaded = true;
        MODAL_LOADER_HIDE.emit({
            forceHide: forceEnd
        });
    }
}
